import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vm4serfd3h: FaireBrandEntity = {
  token: "b_vm4serfd3h",
  type: "brand",
  name: "Label & Decore",
  avatarUrl:
    "https://cdn.faire.com/fastly/508d6a3e4836dd417a2d64f4196f3b1eb7f2b900bea60efa9c36ae6f32be1d88.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d3061056dc8a5fa3fcd1ffd2538fe57d46dbd0bad295860e7a89ac0f6b1150d3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/508d6a3e4836dd417a2d64f4196f3b1eb7f2b900bea60efa9c36ae6f32be1d88.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d3061056dc8a5fa3fcd1ffd2538fe57d46dbd0bad295860e7a89ac0f6b1150d3.png",
  location: "Maxton, NC, USA",
  minimumOrderDollars: 0,
  rating: 4.2,
  reviewCount: 5,
  isInsider: false,
  description:
    "Founded in 2023, Label & Decore was created with a simple vision — to bring creativity, style, and joy into everyday living and celebrations. What began as a small venture has quickly grown into a reliable wholesale destination for gifting products, home décor, and toys.\n\nAt Label & Decore, we believe that every product carries meaning. A well-chosen gift strengthens relationships, a décor piece adds personality to a space, and a toy creates moments of happiness. That’s why we carefully curate our collection to offer products that are trendy, affordable, and full of charm.\n\nWe specialize in providing high-quality products at competitive wholesale prices, helping retailers and businesses stay ahead in a fast-moving market. Our focus is not just on selling, but on building long-term partnerships through trust, consistency, and customer satisfaction.\n\nWith a passion for innovation and a commitment to excellence, Label & Decore continues to grow, adapting to new trends and customer needs. Our goal is to become a trusted name in the wholesale industry known for quality, creativity, and reliability.\n\nLabel & Decore — Creating Moments, Delivering Smiles.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:57.318Z",
    importedBy: "entity-db-cli",
  },
};
